/* download formats */

export const EXTERNAL_SELECT_OPTIONS = [
  { label: "Mine", value: "mine" },
  { label: "Marvelous", value: "marvelous" },
];

export const STATUS_TOTAL = "total";

/* tabs for active key */
export const TABS = [
  { label: "Active Phases", value: 1 },
  { label: "Total Phases", value: STATUS_TOTAL },
];

export const DISABLED_STEPS = [0, 2, 6];

export const URL_KEYS = {
  page: "page",
  limit: "limit",
  active: "active",
  action: "action",
  sortBy: "sortBy",
  sortDir: "sortDir",
  select: "select",
  companyName: "companyName",
  phaseName: "name",
  perPage: "perPage",
  partner: "partner",
  partnerIds: "partnerIds",
  partnerNames: "partnerNames",
  seller: "seller",
  period: "period",
  name: "name",
  status: "status",
  search: "search",
  phase: "phase",
  assignedTo: "assignedTo",
  sellerIds: "sellerIds",
  statuses: "statuses",
  designatedPhaseIds: "designatedPhaseIds",
  includedIn: "includedIn",
  parentCategoryId: "parentCategoryId",
  qualifier: "qualifier",
  dueDate: "dueDate",
  partnerId: "partnerId",
  brandIds: "brandIds",
  excludeBrandIds: "excludeBrandIds",
  categoryId: "categoryId",
  insightful: "insightful",
  keywords: "keywords",
};
